import PropTypes from "prop-types"
import Row from "react-bootstrap/Row";
import { INDIVIDUAL_HEADER_HEIGHT } from "../utils/headers";
import { colorIsDark } from "../utils/general";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useMemo } from "react";

const OptHeader = ({text, backgroundColor="#3f7a47", tooltip=null}) => {
    
    const header = useMemo(() => <div className="bg-dark">
        <Row className="topbar g-0 p-0" style={{
            height: `${INDIVIDUAL_HEADER_HEIGHT}px`,
            minHeight: `${INDIVIDUAL_HEADER_HEIGHT}px`,
            backgroundColor: backgroundColor,
            color: colorIsDark(backgroundColor) ? "#ffffff" : "#000000",
            fontSize: "12px",
            textAlign: "center",
            verticalAlign: "top",
            lineHeight: `${INDIVIDUAL_HEADER_HEIGHT}px`
        }}>
            <p>
                {text}
            </p>
        </Row>
    </div>, [text, backgroundColor]);

    return tooltip 
        ? <OverlayTrigger
                placement={"bottom"}
                overlay={
                    <Tooltip>
                        {tooltip}
                    </Tooltip>
                }
            >
                {header}
            </OverlayTrigger> 
        : header;
};

OptHeader.propTypes = {
  backgroundColor: PropTypes.string,
  text: PropTypes.string,
  tooltip: PropTypes.any
}

export default OptHeader;
